import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppQuery } from '../../../../hooks/use-app-query.hook';
import ApiService from '../../../../services/api-service.util';

export type TemplateFieldAvailability = {
  hasAccelerationDate: boolean;
  hasCliff: boolean;
  hasVesting: boolean;
};

export const useTemplateFieldAvailability = (
  planId: null | string | undefined,
  enabled: boolean,
) => {
  const normalizedPlanId = planId?.trim() ?? '';
  const shouldFetch = enabled && normalizedPlanId.length > 0;

  const { data, isPending, isError } = useAppQuery<TemplateFieldAvailability>({
    queryKey: [QueryKey.GET_TEMPLATE_FIELD_AVAILABILITY, normalizedPlanId],
    queryFn: () =>
      ApiService.get<TemplateFieldAvailability>({
        endpoint: BackendRoute.SHARE_PLANS,
        routePath: ['template-field-availability', normalizedPlanId],
      }),
    enabled: shouldFetch,
  });

  return {
    availability: data ?? null,
    isPending,
    isError,
  };
};
